import { CloseIcon } from 'assets/icons/CloseIcon'
import { DragIcon } from 'assets/icons/DragIcon'
import { WidgetsSelectItem, WidgetsSidebarContainer } from 'pages/Dashboard/Dashboard.styled'
import { IWidgetListItem } from 'pages/HrDashboard/hrDashboardData'
import { Flex, P, SquareIcon } from 'styling/GlobalStyles'
import { BodyText, ParagraphText } from 'styling/Typography'

export const WidgetsSidebar = ({ open, setOpen, setDragging, presentWidgets, saveLayout, sectionWidgets }: IWidgetsSidebar) => {
    const widgets = sectionWidgets.filter(w => !presentWidgets.includes(w.type))
    return <WidgetsSidebarContainer style={open ? { minWidth: '350px', padding: '1rem', opacity: 1, marginLeft: '1rem' } : { width: '0', minWidth: '0', padding: '0', opacity: 0, overflow: 'auto', marginLeft: 0 }}  >
        <Flex width='100%' between >
            <P>Choose widgets</P>
            <CloseIcon onClick={() => {
                saveLayout()
                setOpen(false)
            }} />
        </Flex>
        {
            // eslint-disable-next-line react/jsx-key
            widgets.length ? widgets.map(w => <WidgetsSelectItem
                key={w.title}
                draggable
                onDragStart={() => setDragging(prev => ({ ...prev, width: w.width, type: w.type }))}
                onDragEnd={() => setDragging({ width: 0, type: '', overArea: '' })}
            >
                <DragIcon />
                <SquareIcon color={'#ff9900'} >
                    {w.icon}
                </SquareIcon>
                <div className='text' >
                    <BodyText weight='bold' >{w.title}</BodyText>
                </div>
            </WidgetsSelectItem>) : <p style={{ fontSize: '.8rem', color: 'grey', marginTop: '2rem' }} >All widgets are being used</p>
        }

    </WidgetsSidebarContainer>
}

interface IWidgetsSidebar {
    presentWidgets: string[]
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    setDragging: React.Dispatch<React.SetStateAction<{
        width: number;
        type: string;
        overArea: string
    }>>
    saveLayout: () => void
    sectionWidgets: IWidgetListItem[]
}